/**
 * 游客任务 API 接口
 */
export interface GuestTaskApi {
    /**
     * 刷新游客任务到登录用户
     */
    refreshGuestTasks(): Promise<void>;
}

export const GuestTaskApi = Symbol('GuestTaskApi');

